const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  userInfo: state => state.user.user,
  menuAuth: state => state.user.menuAuth,
  routerAuth: state => state.user.routerAuth,
  buttonAuth: state => state.user.buttonAuth,
  chatList: state => state.user.chatList,
  NIM: state => state.user.NIM,
  chatItemDetial: state => state.user.chatItemDetial,
  currentChat: state => state.user.currentChat,
  allUnread: state => state.user.allUnread,
  userAccount: state => state.user.userAccount,
  loading: state => state.user.loading,
  // sale_index: state => state.user.sale_index,
  // sale_type: state => state.user.sale_type,
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js